import React, { useState, useEffect, useRef } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import MAndEForm from './MAndEForm'
import MAndEView from './MAndEView'
import { SaveAssessmentMAndEForm, SendAssessmentMAndEForm } from '../../redux/actions/assessment'
import EditButton from '../../components/buttons/editButton/EditButton'
import MAndERejectWidget from './MAndERejectWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'

export default function MAndEFormWidget({ schema, preView, ...props }) {
  const history = useHistory()

  const { register, handleSubmit, errors, control, setValue, reset, clearErrors, getValues } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isRejectConfirm, setIsRejectConfirm] = useState(false)
  const [isSendConfirm, setIsSendConfirm] = useState(false)
  const [isRefash, setIsRefash] = useState(false)
  // const [isDraft, setIsDraft] = useState(false)
  const [isLoading, setIsLoading] = useState()

  const [submitSendData, setSubmitSendData] = useState()

  const handleCallSaveService = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await SaveAssessmentMAndEForm(request, request.projectCode)
      if (response) {
        setFormSchema(response)

        sessionStorage.setItem('m_e_id', response.id)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        onRefash()
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('EvaluationMAndEFormWidget HandleCallSaveService Error : ', e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleCallSendService = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await SendAssessmentMAndEForm(request)
      if (response) {
        setFormSchema(response)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setIsRejectConfirm(false)
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleCallSendService Error : ', e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSend = () => {
    let req = {
      id: formSchema.id,
      type: 1,
      note: '',
    }
    setIsSendConfirm(false)
    handleCallSendService(req)
  }
  const onSubmitDaft = () => {
    let data = {
      assessmentType: getValues('assessmentType'),
      reportor: getValues('reportor'),
      startDate: getValues('startDate'),
      endDate: getValues('endDate'),
      managementUnitType: getValues('managementUnitType'),
      managementUnitHead: getValues('managementUnitHead'),
      mentorCount: getValues('mentorCount'),
      delWorkerId: getValues('delWorkerId'),
      workerData: getValues('workerData'),
      assessmentResult: getValues('assessmentResult'),
    }

    console.log('onSubmitDaft:', data)

    onSubmit(data, true)
  }

  const getAssessmentReq = (assessmentDatas) => {
    var result = {}

    for (let item of assessmentDatas) {
      if (item.selection) {
        let questionId = item.selection.name

        result[`${questionId}`] = getValues(`${questionId}`)
        result[`qualitativeData_${questionId}`] = getValues(`qualitativeData_${questionId}`)
        result[`evaluationTeamReflect_${questionId}`] = getValues(
          `evaluationTeamReflect_${questionId}`
        )
        result[`change_${questionId}`] = getValues(`change_${questionId}`)
      }

      if (item.children?.length > 0) {
        var childResult = getAssessmentReq(item.children)
        if (childResult) {
          result = { ...result, ...childResult }
        }
      }
    }

    return result
  }

  const onSubmit = (data, isDraft) => {
    console.log('onSubmit:', data)

    var assessments = appendAssessmentReq(formSchema.assessment.datas, data)

    let req = {
      id: formSchema.id,
      assessmentId: formSchema.assessmentId,
      projectCode: formSchema.projectCode,
      assessmentType: data.assessmentType,
      reportor: data.reportor,
      startDate: data.startDate ? moment(data.startDate).format(DATE_FORMAT) : null,
      endDate: data.endDate ? moment(data.endDate).format(DATE_FORMAT) : null,
      managementUnitType: data.managementUnitType,
      managementUnitHead: data.managementUnitHead,
      mentorCount: data.mentorCount,
      workingGroupDelIds: data.delWorkerId || [],
      workingGroups: data.workerData || [],
      assessments: assessments || [],
      isDraft: isDraft,
    }

    console.log('req : ', req)

    setIsShowConfirm(false)
    handleCallSaveService(req)
  }

  const onSubmitAndSend = (data) => {
    console.log('onSubmitAndSend:', data)
    setSubmitSendData(data)
    setIsShowConfirm(true)
  }

  const appendAssessmentReq = (datas, inputData) => {
    var result = []

    for (let item of datas) {
      if (item.selection) {
        let questionId = item.selection.name

        result.push({
          id: item.selection.id,
          questionId: questionId,
          value: inputData.assessmentResult.get(questionId)?.toString(),
          qualitativeData: inputData.assessmentResult.get(`qualitativeData_${questionId}`),
          evaluationTeamReflect: inputData.assessmentResult.get(
            `evaluationTeamReflect_${questionId}`
          ),
          change: inputData.assessmentResult.get(`change_${questionId}`),
        })
      }

      if (item.children?.length > 0) {
        var childResult = appendAssessmentReq(item.children, inputData)
        if (childResult.length > 0) {
          result.push(...childResult)
        }
      }
    }

    return result
  }

  const handleCancel = () => {
    if (preView) {
      history.push(pathname.assessment.assessmentSettingPage)
    } else {
      history.push(pathname.assessment.assessmentMAndE)
    }
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Panel
        shaded
        // collapsible
        // defaultExpanded
        header={<b>{formSchema?.header || ''}</b>}
        bordered
      >
        {isLoading && <OverlayLoader />}

        {!isRefash && (
          <>
            {!formSchema.disabled ? (
              <MAndEForm
                schema={formSchema}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            ) : (
              <MAndEView schema={formSchema} />
            )}

            <hr />
            <Row style={{ marginTop: 20 }}>
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema.saveDraftBtn && (
                  <SaveButton
                    className={'rs-panel-shaded'}
                    onClick={onSubmitDaft}
                    style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                  >
                    {formSchema.saveDraftBtn}
                  </SaveButton>
                )}
                {formSchema.saveBtn && (
                  <SaveButton
                    className={'rs-panel-shaded'}
                    onClick={() => {
                      handleSubmit(onSubmitAndSend)()

                      if (Object.keys(errors).length > 0) {
                        notification.open('error', {
                          title: 'กรุณากรอกข้อมูลและแบบประเมินให้ครบถ้วน',
                          duration: 5000,
                        })
                      }
                    }}
                    style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                  >
                    {formSchema.saveBtn}
                  </SaveButton>
                )}
                {formSchema.sendBtn && (
                  <SaveButton
                    icon="send"
                    onClick={() => setIsSendConfirm(true)}
                    style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                  >
                    {formSchema.sendBtn}
                  </SaveButton>
                )}

                {formSchema.rejectBtn && (
                  <EditButton
                    icon="send"
                    onClick={() => setIsRejectConfirm(true)}
                    style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                  >
                    {formSchema.rejectBtn}
                  </EditButton>
                )}

                <CancelButton onClick={handleCancel}>ยกเลิก</CancelButton>
              </Col>
            </Row>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={formSchema.saveBtn}
        show={isShowConfirm}
        detail={`ยืนยันการ ${formSchema.saveBtn}`}
        onCancle={() => {
          setIsShowConfirm(false)
        }}
        onConfirm={() => {
          onSubmit(submitSendData, false)
        }}
      />

      <ConfirmWidget
        title={formSchema.sendBtn}
        show={isSendConfirm}
        detail={`ยืนยันการ ${formSchema.sendBtn}`}
        onCancle={() => {
          setIsSendConfirm(false)
        }}
        onConfirm={onSend}
      />

      <MAndERejectWidget
        schema={formSchema}
        isShow={isRejectConfirm}
        onConfirm={handleCallSendService}
        onCancle={() => {
          setIsRejectConfirm(false)
        }}
      />
    </>
  )
}
